import {noop} from '@github-ui/noop'
import {useEffectEvent, useLayoutEffect, useState} from 'react'

import {useElementSizes} from './common/use-element-sizes'

type UseMemexProjectViewRootHeightOpts = {
  onResize?: (measurement: ReturnType<typeof useElementSizes>) => void
}

/**
 * Returns the max height and width of the memex app root element
 * Using a resize observer, these values are updated when the size of the
 * element is changed
 */
export const useMemexProjectViewRootHeight = ({
  onResize: onResizeProp = noop,
}: UseMemexProjectViewRootHeightOpts = {}) => {
  const [memexRootElement, setMemexRootElement] = useState(() => document.getElementById('memex-project-view-root'))
  const measurement = useElementSizes(memexRootElement)

  useLayoutEffect(() => {
    if (!memexRootElement) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setMemexRootElement(document.getElementById('memex-project-view-root'))
    }
  }, [memexRootElement])

  const onResize = useEffectEvent(onResizeProp)
  useLayoutEffect(() => {
    onResize(measurement)
  }, [measurement])
  return measurement
}
